import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { PromiseUtilsService } from 'src/app/shared/services/promise-utils.service';
import { AIChatbotService } from '../../services/ai-chatbot/ai-chatbot.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ai-chatbot-loading',
  templateUrl: './ai-chatbot-loading.component.html',
  styleUrl: './ai-chatbot-loading.component.scss',
  standalone: false,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate(
          '1s ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
  ],
})
export class AiChatbotLoadingComponent implements OnInit, OnDestroy {
  @ViewChild('samplesContainer', { static: false })
  samplesContainer!: ElementRef;

  shownSamples: number = 0;
  showGeneratingSamplesSubscription: Subscription;

  constructor(
    public aiChatbotService: AIChatbotService,
    private promiseUtilsService: PromiseUtilsService
  ) {}

  ngOnInit(): void {
    this.subscribeToShowGeneratingSamples();

    if (this.aiChatbotService.isLoadingTemplates && this.shownSamples === 0) {
      this.showGeneratingSamples();
    }
  }

  ngOnDestroy(): void {
    // Clean up subscription
    if (this.showGeneratingSamplesSubscription) {
      this.showGeneratingSamplesSubscription.unsubscribe();
      this.showGeneratingSamplesSubscription = null;
    }
  }

  private subscribeToShowGeneratingSamples(): void {
    // Unsubscribe from previous subscription if it exists
    if (this.showGeneratingSamplesSubscription) {
      this.showGeneratingSamplesSubscription.unsubscribe();
    }

    this.showGeneratingSamplesSubscription =
      this.aiChatbotService.showLoadingSamples$.subscribe(() => {
        this.showGeneratingSamples();
      });
  }

  async showGeneratingSamples(): Promise<void> {
    await this.promiseUtilsService.delay(1000);
    this.shownSamples = 1;
    await this.scrollPresentationsSamplesToRight();

    await this.promiseUtilsService.delay(1000);
    this.shownSamples = 2;
    await this.scrollPresentationsSamplesToRight();

    await this.promiseUtilsService.delay(1000);
    this.shownSamples = 3;
    await this.scrollPresentationsSamplesToRight();
  }

  scrollPresentationsSamplesToRight = async () => {
    if (this.samplesContainer) {
      await this.promiseUtilsService.delay(100);
      const element = this.samplesContainer.nativeElement;
      element.scrollTo({
        left: element.scrollWidth,
        behavior: 'smooth',
      });
    }
  };
}
